// ============================================================
// FeedbackTrigger — small, calm button that opens the Sentry
// User Feedback dialog. Lives in the TopBar so it's always
// reachable but never floats over the shell as a tacky widget.
//
// Hidden entirely when Sentry is not initialized.
// ============================================================

import { isFeedbackAvailable, isInitialized, openFeedbackDialog, recordShellAction } from './sentry'

export default function FeedbackTrigger() {
  if (!isInitialized() || !isFeedbackAvailable()) return null

  return (
    <button
      type="button"
      onClick={() => {
        recordShellAction('feedback.open')
        openFeedbackDialog()
      }}
      title="Report an issue"
      style={{
        border: '1px solid rgba(255,255,255,0.08)',
        background: 'rgba(255,255,255,0.04)',
        color: '#dbe5ff',
        borderRadius: 10,
        padding: '8px 12px',
        cursor: 'pointer',
        fontSize: 11,
        fontWeight: 600,
        letterSpacing: '0.06em',
        textTransform: 'uppercase',
        fontFamily: 'var(--font-mono, monospace)',
      }}
    >
      Feedback
    </button>
  )
}
